export const exchangeRateKeys = {
  all: ['exchange-rates'] as const,
  list: () => [...exchangeRateKeys.all, 'list'] as const,
};
